import { ApolloQueryResult, gql } from '@apollo/client'

import { client } from '../client'

const FIND_DRIVER_BY_DOCUMENT_QUERY = gql`
query FindDriverByDocument($driverIdNo: String!, $driverIdType: String!, $phoneNumber: String) {
  findDriverByDocument(driverIdNo: $driverIdNo, driverIdType: $driverIdType, phoneNumber: $phoneNumber) {
    driverName
    phoneNumber
    driverIdNo
    driverIdType
  }
}
`

type FindDriverByDocumentVars = {
  driverIdNo: string,
  driverIdType: string,
  phoneNumber?: string,
}

type FindDriverByDocumentData = {
  findDriverByDocument: {
    driverName: string,
    phoneNumber: string,
    driverIdNo: string,
    driverIdType: string,
  } | null
}

export const findDriverByDocument = async (
  args: FindDriverByDocumentVars,
): Promise<ApolloQueryResult<FindDriverByDocumentData>> => {
  return await client.query<FindDriverByDocumentData, FindDriverByDocumentVars>({
    query: FIND_DRIVER_BY_DOCUMENT_QUERY,
    variables: args,
  })
}
